define('SageDotCom/DataLayer/Global/footer',['jquery',
    'SageDotCom/DataLayer/tealium',
    'SageDotCom/DataLayer/Events/bottomNav'],
    function ($, analytics, eventSchema) {
        function globalFooterTracking() { }

        globalFooterTracking.prototype.initialize = function initialize() {
            // find all anchors not nested inside a tracked element
            $("footer a:not([data-xpr-state], [data-tracking])").each(function (key, value) {
                $(value).on('click', function (event) {
                    var data = eventSchema.GenerateEventMetadata(event.currentTarget);
                    analytics.event(data);
                });

                $(value).closest('[id]').attr('data-tracking', eventSchema.getName());
            });
        }

        return new globalFooterTracking();
    });
